module.exports = __webpack_public_path__ + "officialStatic/img/school5Logo.0382a3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/school5Logo.png
// module id = iWfb
// module chunks = 0